module.exports = __webpack_public_path__ + "img/127.b7579242.jpg";